module.exports = __webpack_public_path__ + "res/13-img_play.2dee15efb0d8d77fcb031f30d7776f60.webp";